"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeMarkdown = exports.getFileUrl = exports.sanitizeInlineMd = void 0;
const sanitizeInlineMd = (input) => {
    if (!input) {
        return '';
    }
    let s = input.replace(/^\s{0,3}#{1,6}\s+/g, '');
    s = s.replace(/\n+/g, ' ');
    s = s.replace(/\s{2,}/g, ' ');
    return s.trim();
};
exports.sanitizeInlineMd = sanitizeInlineMd;
const getFileUrl = (file, context) => {
    if (file.source === 'url' && file.url) {
        return file.url;
    }
    if (context.resolveFileUrl) {
        return context.resolveFileUrl(file);
    }
    return file.key || file.id || '';
};
exports.getFileUrl = getFileUrl;
const normalizeMarkdown = (input) => {
    const lines = input.split('\n');
    let inCode = false;
    const out = [];
    let blankCount = 0;
    for (const line of lines) {
        const isFence = line.trim().startsWith('```');
        if (isFence) {
            inCode = !inCode;
            while (blankCount-- > 0) {
                out.push('');
            }
            blankCount = 0;
            out.push(line);
            continue;
        }
        if (!inCode) {
            if (line.trim() === '') {
                blankCount++;
                if (blankCount <= 2) {
                    out.push('');
                }
            }
            else {
                blankCount = 0;
                out.push(line);
            }
        }
        else {
            out.push(line);
        }
    }
    return out.join('\n');
};
exports.normalizeMarkdown = normalizeMarkdown;
